import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsSoftwareAppsFieldsRoute: InvariantJiraRoute = {
	name: 'project-settings-software-apps-fields',
	path: '/jira/software/projects/:projectKey/settings/apps/app-fields',
	exact: true,
};
